export default __webpack_public_path__ + "static/media/4.23b4e5c4.svg";